import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, LogIn } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { BRAND } from "../lib/brand";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] bg-[#F1F5F9] flex items-center justify-center px-4" data-testid="login-page">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-sm p-8 lg:p-10">
        <div className="flex items-center gap-3 mb-6">
          <img src={BRAND.logo} alt="Amplartic" className="h-12 w-12 object-contain" />
          <div>
            <div className="font-display font-extrabold text-[#1E2A78] tracking-tight">AMPLARTIC</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Admin Portal</div>
          </div>
        </div>
        <h1 className="text-2xl font-display font-bold text-[#0F172A]">Sign in</h1>
        <p className="text-sm text-slate-600 mt-1">Manage shipments, requests and forms.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-2">Email</label>
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 bg-white border border-slate-200 rounded-sm outline-none focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/20 text-sm"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-2">Password</label>
            <input
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 bg-white border border-slate-200 rounded-sm outline-none focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/20 text-sm"
              data-testid="login-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full px-6 py-3 bg-[#1E2A78] text-white font-semibold rounded-sm hover:bg-[#17205E] inline-flex items-center justify-center gap-2 disabled:opacity-60"
            data-testid="login-submit"
          >
            {loading ? "Signing in..." : (<><LogIn className="h-4 w-4" /> Sign In</>)}
          </button>
        </form>

        <div className="mt-6 pt-6 border-t border-slate-200 flex items-center gap-2 text-xs text-slate-500">
          <Lock className="h-3.5 w-3.5" />
          Authorized personnel only. All access is logged.
        </div>
      </div>
    </div>
  );
}
